import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useDeleteNote } from "../../hooks/useCrm";
import { useEditTargetUser } from "../../hooks/useManagement";
import { DataPicker } from "../DataPicker/DataPicker";
import { InputField1 } from "../InputField1/InputField1";
import { MiladiToShamsi, ShamsiToMiladi } from "../../utils/Miladi_To_Shamsi";
import { formatDate } from "../../utils/formatDate";
const initvalue = {
  user_sale_target_id: "",
  amount: "",
};
export const EditTargetUserModal = ({ show, handleClose, target }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: editTarget, isLoading } = useEditTargetUser();
  const handleEdit = async (datom) => {
    await editTarget(datom).then(() => setForm(initvalue));
  };
  useEffect(() => {
    setForm({
      ...form,
      amount: target?.AmountUserSaleTarget,
      user_sale_target_id: target?.IdUSerSaleTarget,
    });
  }, [target]);
  return (
    <BootstrapModal
      modaltitle="ویرایش تارگت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <InputField1
            label="تارگت"
            onChange={(e) => setForm({ ...form, amount: e.target.value })}
            value={form?.amount}
          />
        </div>
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleEdit(form);
              handleClose();
            }}
          >
            ثبت
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
